import { PropsWithChildren, useMemo } from "react";
import { TelegramWebAppContext } from "@shared/features/common/TelegramWebApp.context.ts";
import { useTelegramWebAppProvider } from "utils/hooks/useTelegramWebApp.ts";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay.tsx";

const TelegramWebAppProvider = ({ children }: PropsWithChildren) => {
  const {
    isInitialized,
    telegramStartValue,
    initData,
    urlInitData,
    telegramInitData,
  } = useTelegramWebAppProvider();

  const value = useMemo(() => {
    return {
      telegramStartValue,
      initData,
      urlInitData,
      telegramInitData,
    };
  }, [telegramStartValue, initData, urlInitData, telegramInitData]);

  if (!isInitialized) {
    return (
      <LoadingSpinnerOverlay
        isLoading={true}
        hideContentWhileLoading={true}
        spinnerSize="large"
      />
    );
  }

  return (
    <TelegramWebAppContext.Provider value={value}>
      {children}
    </TelegramWebAppContext.Provider>
  );
};

export default TelegramWebAppProvider;
